module.exports = __webpack_public_path__ + "static/media/quartz_301.e823ea85.ico";